import React, {forwardRef} from 'react';
import Button from '@mui/material/Button';

import SVGIcons, {SVGType} from '@components/SVGIcon';
import {ButtonProps} from './Button.type';

import './Button.style.scss';

const CustomButton = forwardRef<HTMLButtonElement, ButtonProps>(({testId, iconType, ...props}, ref) => {
  const DISABLED_BUTTON_STYLE = {
    'cursor': 'not-allowed',
    'pointerEvents': 'all !important',
    'background': '#c5c5c5',
    'color': '#8a8a8a',
    'outline': '2px solid #c5c5c5',
    'svg': {
      path: {
        fill: '#8a8a8a',
      },
    },
    '&:hover': {
      pointerEvents: 'all !important',
      background: '#c5c5c5 !important',
      color: '#8a8a8a',
      outline: '2px solid #c5c5c5',
      boxShadow: 'inset -500px 0 0 0 #c5c5c5',
      svg: {
        path: {
          fill: '#8a8a8a',
        },
      },
    },
  };

  const ButtonStyle = {
    'borderRadius': '75px',
    'color': '#fff',
    'background': '#e35205',
    'textTransform': 'none',
    'fontSize': '14px',
    'fontWeight': '500',
    'padding': '16px 24px',
    'height': '40px',
    '&:disabled': DISABLED_BUTTON_STYLE,
    '&:hover': {
      background: '#e35205',
    },
    ...(props.style && {...props.style}),
  };
  const {children, onClick, className} = props;

  const getIcon = (type: string) => <SVGIcons type={type as SVGType} />;

  return (
    <Button
      {...props}
      ref={ref}
      endIcon={props.endIconType && getIcon(props.endIconType)}
      onClick={onClick}
      startIcon={iconType && getIcon(iconType)}
      sx={ButtonStyle}
      className={`${className}`}
      data-testid={testId}
      disableRipple={props.disableRipple}
      data-aos={props['data-aos']}
      disabled={props.disabled}
      type={props.type}
      data-aos-delay={props['data-aos-delay']}>
      {children}
    </Button>
  );
});

export default CustomButton;

